import { changeRangeValueAction } from './changeRangeValueAction';

export const changeWorkplaceCountMaxAction = (value: number): ReturnType<typeof changeRangeValueAction> =>
  changeRangeValueAction({ fieldName: 'workplaceCount', rangeValueKey: 'max', value });
